const GREEN = "#3DBB2C";
const NAVY = "#0D2B5E";

export const VisionMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-hidden="true">
    <g stroke={GREEN} strokeWidth="4" fill="none">
      <circle cx="50" cy="50" r="42" />
      <circle cx="50" cy="50" r="24" />
    </g>
    <g fill={GREEN}>
      <circle cx="50" cy="8" r="6" />
      <circle cx="92" cy="50" r="6" />
      <circle cx="50" cy="92" r="6" />
      <circle cx="8" cy="50" r="6" />
    </g>
    <circle cx="50" cy="50" r="14" fill={GREEN} />
    <circle cx="45" cy="45" r="4.6" fill="#fff" />
  </svg>
);

export const VisionLogo = ({ variant = "dark", size = 34, showText = true, className = "" }) => {
  const textColor = variant === "light" ? NAVY : "#FFFFFF";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="vision-logo">
      <VisionMark size={size} />
      {showText && (
        <span className="inline-flex flex-col leading-none">
          <span style={{ color: textColor, fontFamily: "'Outfit', sans-serif", fontWeight: 800, letterSpacing: "-0.01em", fontSize: size * 0.6 }}>VISION</span>
          <span style={{ color: GREEN, fontFamily: "'Outfit', sans-serif", fontWeight: 800, letterSpacing: "0.22em", fontSize: size * 0.26, alignSelf: "flex-end", marginTop: 1 }}>POS</span>
        </span>
      )}
    </span>
  );
};

export default VisionLogo;
